<script setup lang="ts">
import { watch, ref, onMounted } from 'vue';
import { ContactChannels } from '@/models/ContactChannels';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  setEmailError: {
    type: Function,
    required: true,
  },
  isError: {
    type: Boolean,
    default: false,
  },
});

const emailInput = defineModel({
  type: String,
  default: '',
});

const emailRef = ref<HTMLInputElement | null>(null);

function focusInput() {
  if (emailRef.value) {
    emailRef.value.focus();
  }
}

watch(emailInput, () => {
  if (!props.isError) return;
  validateEmail();
});

function validateEmail() {
  if (!emailInput.value) return;

  props.setEmailError(!ContactChannels.isValidEmail(emailInput.value));
}

onMounted(focusInput);
</script>

<template>
  <input
    name="email-input"
    id="email-input"
    ref="emailRef"
    class="border-light-border bg-light-background text-light-primary dark:border-dark-semi-transparent dark:bg-dark-list-bg dark:text-dark-list-text right-0 block h-12 w-full rounded-lg border px-4 text-base outline-none"
    autocomplete="email"
    placeholder="Enter email address"
    type="email"
    v-model="emailInput"
    :disabled="disabled"
    data-test="input-email"
    @blur="validateEmail"
    @mouseleave="validateEmail"
  />
</template>
